import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Card } from '../components/ui/card';
import { Shield, Mail } from 'lucide-react';

const FAQ = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const faqs = [
    { q: t.faq1Q, a: t.faq1A },
    { q: t.faq2Q, a: t.faq2A },
    { q: t.faq3Q, a: t.faq3A },
    { q: t.faq4Q, a: t.faq4A },
    { q: t.faq5Q, a: t.faq5A },
    { q: t.faq6Q, a: t.faq6A },
    { q: t.faq7Q, a: t.faq7A },
    { q: t.faq8Q, a: t.faq8A },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t.faqTitle}
            </h1>
          </div>

          <Card className="p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left">
                    <span className="font-semibold">{faq.q}</span>
                  </AccordionTrigger>
                  <AccordionContent>
                    <p className="text-gray-600 leading-relaxed">{faq.a}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Card>

          {/* Program support contact */}
          <section className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6" aria-labelledby="faq-support-heading">
            <div className="flex gap-3 items-start">
              <Mail className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" aria-hidden="true" />
              <div className="flex-1 min-w-0">
                <h2 id="faq-support-heading" className="text-lg font-semibold text-gray-900 mb-2">
                  {t.supportHeading}
                </h2>
                <p className="text-gray-700 mb-3">
                  {t.supportPrompt}
                </p>
                <p className="mb-3">
                  <span className="text-gray-700">{t.supportEmailLabel}:{' '}</span>
                  <a
                    href="mailto:MB.RCMP.CAPTURE@rcmp-grc.gc.ca"
                    className="text-blue-700 underline underline-offset-2 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-blue-50 break-all"
                  >
                    MB.RCMP.CAPTURE@rcmp-grc.gc.ca
                  </a>
                </p>
                <p className="text-sm text-gray-600">
                  {t.supportEmailDoNotReport}
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default FAQ;